import { Badge, Icon } from '@/components'

import styles from './Anchor.module.scss'

export const Anchor = ({
  id,
  icon,
  text,
  badgeText,
  isActive,
  tagName = 'button',
  onClick = () => {},
  ...props
}) => {
  const CustomTag = tagName

  return (
    <CustomTag
      id={id}
      className={`
        ${styles.anchor} 
        ${isActive && styles['anchor--active']}
      `}
      onClick={onClick}
      {...props}
    >
      <div className={styles.anchor__icons}>
        <Icon size="small" name={icon} color={isActive ? 'white' : 'blue'} />

        {badgeText && (
          <Badge round color="red" icon="equifax-stars" text={badgeText} />
        )}
      </div>

      <p>{text}</p>
    </CustomTag>
  )
}
